export const colors = [
  { color: "#ff6b6b", name: "Red" },
  { color: "#4ecdc4", name: "Teal" },
  { color: "#45b7d1", name: "Blue" },
  { color: "#96ceb4", name: "Green" },
  { color: "#ffeaa7", name: "Yellow" },
  { color: "#fd79a8", name: "Pink" },
  { color: "#a29bfe", name: "Purple" },
  { color: "#fd7f28", name: "Orange" },
  { color: "#2d3436", name: "Black" },
  { color: "#6c5ce7", name: "Indigo" },
];

export const words = [
  { en: "Clock", tel: "గడియారం" },
  { en: "Book", tel: "పుస్తకం" },
  { en: "Apple", tel: "ఆపిల్" },
  { en: "House", tel: "ఇల్లు" },
  { en: "Car", tel: "కారు" },
];
